import { useState, useEffect } from 'react';
import { fetchInternationalMarketGroups } from '../../../../../services/backendAPI';

export const SECTION_NAMES = {
  US_STOCK: 'US Stock',
  CRYPTO: 'Crypto',
  FOREX_MAJOR: 'Forex Major',
  COMMODITIES: 'Commodities',
};

export const SECTION_TITLES = {
  [SECTION_NAMES.US_STOCK]: 'US Stocks',
  [SECTION_NAMES.CRYPTO]: 'Crypto',
  [SECTION_NAMES.FOREX_MAJOR]: 'Forex Major',
  [SECTION_NAMES.COMMODITIES]: 'Commodities',
};

export const useInternationalData = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [sections, setSections] = useState({
    [SECTION_NAMES.US_STOCK]: [],
    [SECTION_NAMES.CRYPTO]: [],
    [SECTION_NAMES.FOREX_MAJOR]: [],
    [SECTION_NAMES.COMMODITIES]: [],
  });

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(false);

    fetchInternationalMarketGroups()
      .then((response) => {
        if (cancelled) return;
        const data = response?.result?.data ?? [];
        
        // Helper to extract instruments strictly matching the allowed names
        const findInstruments = (name) =>
          data.find((g) => g.name === name)?.instruments ?? [];

        setSections({
          [SECTION_NAMES.US_STOCK]: findInstruments(SECTION_NAMES.US_STOCK),
          [SECTION_NAMES.CRYPTO]: findInstruments(SECTION_NAMES.CRYPTO),
          [SECTION_NAMES.FOREX_MAJOR]: findInstruments(SECTION_NAMES.FOREX_MAJOR),
          [SECTION_NAMES.COMMODITIES]: findInstruments(SECTION_NAMES.COMMODITIES),
        });
        setLoading(false);
      })
      .catch(() => {
        if (!cancelled) {
          setError(true);
          setLoading(false);
        }
      });

    return () => { cancelled = true; };
  }, []);

  return { loading, error, sections };
};
